import{s as u}from"./storefront.js";const w="gift-card",s="boarderie:pending-gift-card",f="2025-10",l=30*24*60*60*1e3,C=`
  mutation cartGiftCardCodesAdd($cartId: ID!, $giftCardCodes: [String!]!) {
    cartGiftCardCodesAdd(cartId: $cartId, giftCardCodes: $giftCardCodes) {
      cart {
        id
        appliedGiftCards {
          lastCharacters
          presentmentAmountUsed {
            amount
            currencyCode
          }
        }
      }
      userErrors {
        field
        message
      }
    }
  }
`,p=`
  query cartAppliedGiftCards($cartId: ID!) {
    cart(id: $cartId) {
      appliedGiftCards {
        lastCharacters
        presentmentAmountUsed {
          amount
          currencyCode
        }
      }
    }
  }
`;function A(r){return typeof r!="string"?"":r.replace(/\s+/g,"")}function g(r,t){const e=A(t);if(!e||!Array.isArray(r))return!1;const a=e.slice(-4).toLowerCase();return r.some(n=>{var c;return((c=n==null?void 0:n.lastCharacters)==null?void 0:c.toLowerCase())===a})}function G(){let r;try{r=window.localStorage.getItem(s)}catch{return null}if(!r)return null;let t;try{t=JSON.parse(r)}catch{return o(),null}return!(t!=null&&t.code)||!Number.isFinite(t.savedAt)||Date.now()-t.savedAt>l?(o(),null):t}function y(r){try{window.localStorage.setItem(s,JSON.stringify(r))}catch{}}function o(){try{window.localStorage.removeItem(s)}catch{}}async function m(){const r=await fetch(`${window.Shopify.routes.root}cart.js`);if(!r.ok)throw new Error(`cart.js responded ${r.status}`);return r.json()}function i(r,t){return u(r,t,{apiVersion:f})}function d(r){return`gid://shopify/Cart/${r}`}async function h(r,t){const e=await i(C,{cartId:d(r),giftCardCodes:[t]}),a=e==null?void 0:e.cartGiftCardCodesAdd;if(!a)throw new Error("Storefront API returned no cartGiftCardCodesAdd payload");return a}async function S(r){var e;const t=await i(p,{cartId:d(r)});return((e=t==null?void 0:t.cart)==null?void 0:e.appliedGiftCards)||[]}function _(r){const t=Number.parseFloat(r==null?void 0:r.amount);if(!Number.isFinite(t)||!(r!=null&&r.currencyCode))return"";try{return new Intl.NumberFormat(void 0,{style:"currency",currency:r.currencyCode}).format(t)}catch{return`${t.toFixed(2)} ${r.currencyCode}`}}export{w as G,h as a,_ as b,o as c,m as f,g,A as n,S as q,G as r,y as w};
//# sourceMappingURL=gift-card-utils.js.map
